"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const selectors_1 = require("src/stores/exportedStore/loader/selectors");
const useMainLoader_1 = require("src/hooks/useMainLoader");
const MainRoutes_1 = __importDefault(require("./pages/MainRoutes"));
const useLocalStorage_1 = require("src/hooks/useLocalStorage");
const sharedUtils_1 = require("src/utils/sharedUtils");
const App = () => {
    const loader = (0, reduxHooks_1.useAppSelector)(selectors_1.selectLoader);
    (0, react_1.useEffect)(() => {
        (0, useMainLoader_1.controlLoader)(loader);
    }, [loader]);
    (0, react_1.useEffect)(() => {
        const existedUTMs = (0, useLocalStorage_1.getLocalStorageItem)("utm");
        if (existedUTMs !== null) {
            return;
        }
        const utms = (0, sharedUtils_1.getUTMs)(window.location.href);
        if (Object.keys(utms).length === 0) {
            return;
        }
        (0, useLocalStorage_1.setLocalStorageItem)("utm", JSON.stringify(utms));
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(MainRoutes_1.default, {}) }) }));
};
exports.default = App;
